import React from "react";
import classnames from "classnames";
import cssClass from "./Section.module.scss";

const Section = ({
  children,
  className,
  backgroundShape,
  verticalPadding,
  largeVerticalPadding,
  bottomVerticalPadding,
}) => {
  const classes = classnames(cssClass.section, className, {
    [cssClass.verticalPadding]: verticalPadding,
    [cssClass.bottomVerticalPadding]: bottomVerticalPadding,
    [cssClass.largeVerticalPadding]: largeVerticalPadding,
  });

  return (
    <section className={classes}>
      <div className={cssClass.inner}>{children}</div>
      {backgroundShape && backgroundShape}
    </section>
  );
};

export default Section;
